import {useCallback, useState} from 'react';

export function useBoolean(initialState: boolean = false) {
    const [value, setValue] = useState(initialState);

    const setTrue = useCallback(() => {
        setValue(true);
    }, []);

    const setFalse = useCallback(() => {
        setValue(false);
    }, []);

    const toggle = useCallback(
        (state?: boolean) => {
            if (typeof state === 'boolean') {
                setValue(state);
            } else {
                setValue(!value);
            }
        },
        [value],
    );

    return {
        value,
        setTrue,
        setFalse,
        toggle,
    };
}
